import Rails from '@rails/ujs';
import { Turbo } from '@hotwired/turbo-rails';
import 'iframe-resizer';
import '../application/vendor/jquery.watermark';
import '../application/v2.scss';
import '../application/public.scss';
import '../styleguide/styleguide';

import FlashMessage from '../application/app/flash_message';
import ToggleShown from '../application/app/toggle_shown';
import CopyToClipboard from '../application/app/copy_to_clipboard';
import ToggleOpen from '../application/app/toggle_open';
import SidePanel from '../application/app/sidepanel';
import SidePanelForm from '../application/app/sidepanel_form';
import DarkMode from '../application/app/dark_mode';
import MobileDropdown from '../application/app/mobile_dropdown';
import SubmitForm from '../application/app/submit_form';
import UserTimeZone from '../application/app/user_time_zone';
import ToggleCollapse from '../application/app/toggle_collapse';
import ItemsMasks from '../application/app/items_masks';
import GroupSwitchOnOff from '../application/app/group_switch_on_off';
import SyncEditor from '../application/app/sync_editor';
import WebShare from '../application/app/web_share';
import PageTheme from '../application/app/page_theme';

window.Turbo = Turbo;

document.addEventListener('turbo:load', () => {
  DarkMode.start();
  FlashMessage.start();
  ToggleShown.start();
  CopyToClipboard.start();
  ToggleOpen.start();
  ToggleCollapse.start();
  SidePanel.start();
  SidePanelForm.start();
  MobileDropdown.start();
  SubmitForm.start();
  UserTimeZone.start();
  ItemsMasks.start();
  GroupSwitchOnOff.start();
  SyncEditor.start();
  WebShare.start();
  PageTheme.start();
});

Rails.start();
